import React, {useContext} from 'react'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import clsx from 'clsx'
import {isEmpty, isEqual} from 'lodash'
import Stepper from '@material-ui/core/Stepper'
import CheckCircle from '@material-ui/icons/CheckCircle'
import CheckIcon from '@material-ui/icons/Check'
import RadioButtonUncheckedRounded from '@material-ui/icons/RadioButtonUncheckedRounded'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepConnector from '@material-ui/core/StepConnector'
import StepContent from '@material-ui/core/StepContent'
import {navigationSteps, userProgressArr} from './constants'
import {upsertSettings} from './action'
import ApAnalytics from '../../services/ApAnalytics'
import {UserContext} from '../../context/UserContext'

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    width: '5%',
    zIndex: 1,
    fontSize: 18,
  },
})

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles()
  const {active, completed} = props

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <CheckCircle style={{fill: '#3473ff'}} /> : <RadioButtonUncheckedRounded />}
    </div>
  )
}

const QontoConnector = withStyles({
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
  },
})(StepConnector)

export default function VerticalLinearStepper(props) {
  function usePrevious(value) {
    const ref = React.useRef()
    React.useEffect(() => {
      ref.current = value
    })
    return ref.current
  }

  const [activeStep, setActiveStep] = React.useState(0)
  const [steps, setSteps] = React.useState(navigationSteps)
  const [confirmStep, setConfirmStep] = React.useState(false)
  const {isConfigurationDone, response} = props
  const user = useContext(UserContext)
  const prevResponse = usePrevious(response)
  const handleProgress = React.useCallback(
    async progress => {
      try {
        const arrLength = steps[activeStep].completed.length
        const title = steps[activeStep].completed[arrLength - 1]
        await upsertSettings({
          configurations_attributes: {
            user_progress: Math.ceil(progress),
            user_progress_steps: title,
          },
        })
        setConfirmStep(false)
      } catch (err) {
        // console.log('err', err)
      }
    },
    [activeStep, steps]
  )

  const sendLoaderValuetoIframe = React.useCallback(() => {
    const percentage = calculatePercentage(steps)
    if (percentage < 102) {
      window.parent.postMessage(
        {key: 'USER_PROGRESS', value: percentage},
        process.env.REACT_APP_WIZARD_DOMAIN
      )
      props.setProgressStep(percentage)
    }
  }, [props, steps])

  const setStepperData = React.useCallback(
    response => {
      const index = userProgressArr.findIndex(c => c === response.user_progress_steps)
      const completedProgress = [...userProgressArr].splice(0, index + 1)
      const activeProgress = [...userProgressArr].splice(0, index + 2)
      const newSteps = steps.map(step => {
        const enums = step.subItems.map(c => c.enum)
        step.completed = enums.filter(element => completedProgress.includes(element))
        step.active = enums.filter(element => activeProgress.includes(element))
        return step
      })
      setSteps([...newSteps])
    },
    [steps]
  )

  const handleNext = async (subItem, step, subItemIndex, isCompleted) => {
    if (steps[step].subItems.length - 1 !== subItemIndex) {
      steps[step].active = [
        ...new Set([...steps[step].active, ...[steps[step].subItems[subItemIndex + 1].enum]]),
      ]
    } else if (steps[step + 1] && steps[step + 1].active) {
      steps[step + 1].active = [
        ...new Set([...steps[step + 1].active, ...[steps[step + 1].subItems[0].enum]]),
      ]
    }
    steps[step].completed = [
      ...new Set([...steps[step].completed, ...[steps[step].subItems[subItemIndex].enum]]),
    ]

    const stepComp = isCompleted ? `Completed ${subItem.title}` : `skipped ${subItem.title}`

    const userDetails = {
      user: {
        id: user?.details?.id,
        first_name: user?.details?.first_name,
        last_name: user?.details?.last_name,
        email: user?.details?.email,
      },
    }
    ApAnalytics.trackData(stepComp, userDetails)
    await handleProgress(calculatePercentage(steps))
    setSteps([...steps])
  }

  const handleHyperLink = subItem => {
    if (subItem.url) {
      window.open(`${subItem.url}`, '_blank')
    }
    setConfirmStep(subItem.enum)
  }

  const subItemClass = (step, subItem) => {
    if (!isConfigurationDone) {
      return 'incomplete-subitem'
    }

    if (step.active.includes(subItem.enum) && !step.completed.includes(subItem.enum)) {
      return 'active-subitem'
    } else if (!step.completed.includes(subItem.enum)) {
      return 'incomplete-subitem'
    } else {
      return 'stepper-subitem'
    }
  }

  const calculatePercentage = subItems => {
    return subItems.map(c => c.completed).flat().length * 14.28
  }

  React.useEffect(() => {
    // console.log('prevResponse', prevResponse)
    // console.log('response', response)

    if (!isEmpty(response) && !isEqual(prevResponse, response)) {
      setStepperData(response)
    }
    // eslint-disable-next-line
  }, [response])

  React.useEffect(() => {
    if (activeStep < 2 && steps[activeStep].completed.length > steps[activeStep].size - 1) {
      setActiveStep(prevActiveStep => prevActiveStep + 1)
    }
    // console.log({steps})
    if (steps[0].completed.length > 1) {
      sendLoaderValuetoIframe()
    }
  }, [activeStep, steps, sendLoaderValuetoIframe])

  return (
    <div>
      <Stepper
        activeStep={isConfigurationDone ? activeStep : null}
        orientation="vertical"
        connector={<QontoConnector />}
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel StepIconComponent={QontoStepIcon}>{step.label}</StepLabel>
            <StepContent active>
              {step.subItems.map((subItem, subItemIndex) => (
                <div>
                  <span
                    className={
                      step.completed.includes(subItem.enum) && isConfigurationDone ? '' : 'pr-24'
                    }
                  >
                    {step.completed.includes(subItem.enum) && isConfigurationDone && (
                      <CheckIcon style={{fill: '#3473ff', width: '9%', paddingRight: '5px'}} />
                    )}
                  </span>
                  <span
                    className={subItemClass(step, subItem)}
                    onClick={() => {
                      if (!(step.completed.includes(subItem.enum) && isConfigurationDone)) {
                        handleHyperLink(subItem)
                      }
                    }}
                  >
                    {subItem.title}
                  </span>
                  {confirmStep === subItem.enum && step.active.includes(subItem.enum) && (
                    <div className="row mr-13">
                      <div className="confirm-step-cta">
                        <span
                          className="confirm-cta-txt"
                          onClick={() => handleNext(subItem, index, subItemIndex, true)}
                        >
                          Completed
                        </span>
                      </div>
                      <div
                        className="skip-step-cta"
                        onClick={() => handleNext(subItem, index, subItemIndex, false)}
                      >
                        <span className="confirm-cta-txt">Skipped</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  )
}
